import cn from 'classnames';

interface Card extends Pick<JSX.IntrinsicElements['div'], 'className'> {
  children?: React.ReactNode;
  header?: React.ReactNode;
  title?: React.ReactNode;
}

export function Card({ children, className, header, title }: Card) {
  const hasHeader = Boolean(header);
  const hasTitleOrHeader = hasHeader || Boolean(title);

  return (
    <div className={cn('rounded-[8px] bg-white p-5', className)}>
      {hasTitleOrHeader && (
        <div
          className={cn(
            'box-content flex justify-between gap-5 max-sm:flex-col sm:h-8 sm:items-center',
            {
              'pb-2': !hasHeader,
              'pb-4': hasHeader,
            },
          )}
        >
          {title && (
            <h2 className="text-18/120% font-semibold text-gray-900">
              {title}
            </h2>
          )}
          {header}
        </div>
      )}
      {children}
    </div>
  );
}
